import React, {Component} from 'react';
import Page from '../../components/Page';
import {getProjects} from '../../actions/projects';
import Select from 'react-select';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import {getAuthenticatedUser} from '../../actions/authentication';
import {submitMyReport, getMyReports, deleteMyReport} from '../../actions/myreports';

import './styles.css';



const DEFAULT_STATE = {
    text: '',
    projectId: '',
    month: moment().month(),
    year: moment().year()
};

class MyReports extends Component {

    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE;
        this._onClickSubmit = this._onClickSubmit.bind(this);
        this._onChangeInput = this._onChangeInput.bind(this);
        this._getProjectName = this._getProjectName.bind(this);
        this._onClickDeleteReport = this._onClickDeleteReport.bind(this);
        this._onChangeSelect = this._onChangeSelect.bind(this);
    }

    _onClickSubmit() {
        let data = Object.assign({}, this.state, {userId: this.props.user._id});
        this.props.dispatch(submitMyReport(()=>{}, data));
        this.setState({text: ''});
    }

    _onClickDeleteReport(report) {
        this.props.dispatch(deleteMyReport(()=>{}, report._id));
    }

    _onChangeInput(property, event) {
        let state = Object.assign({}, this.state);
        state[property] = event.target.value;
        this.setState(state);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.user &&
            nextProps.user.projects &&
            nextProps.user.projects.length &&
            this.state.projectId === '') {
            this.setState({projectId: nextProps.user.projects[0]});
        }
    }

    componentWillMount() {
        this.props.dispatch(getAuthenticatedUser());
        this.props.dispatch(getProjects());
        this.props.dispatch(getMyReports(()=>{}, this.state.month, this.state.year));
    }

    _getProjectName(projectId) {
        let project = _.find(this.props.projects, {_id: projectId});
        return (project && project.isActive && project.name) || '';
    }


    _onChangeSelect(property, option) {
        let value = (option && option.value) || '';
        if (property === 'month' && !value) {
            value = 0;
        }
        let state = Object.assign({}, this.state);
        state[property] = value;
        this.setState(state);

        let year = this.state.year;
        let month = value;

        this.props.dispatch(getMyReports(()=>{}, month, year));
    }

    render() {
        let options = [];
        let userProjects = this.props.user.projects || [];
        userProjects.forEach((id, index) => {
            let name = this._getProjectName(id);
            if (name) {
                options.push(<option key={'project_'+ index} value={id}> {name} </option>);
            }
        });

        let myReports = [];

        this.props.myReports.forEach((report, index) => {
            if (report.projectId !== this.state.projectId) {
                return;
            }
            let date = moment(report.createdAt);
            myReports.unshift(<div key={'report_' + index} className="My-Report-Entry">
                <div className="My-Report-Container">
                    <div className="My-Report-Head">
                        <span className="My-Report-Info"><i className="fa fa-clock-o" aria-hidden="true"/> {date.format('DD/MM/YYYY HH:mm')}</span>
                        <button onClick={() => this._onClickDeleteReport(report)} className="btn btn-default" title="Delete entry">
                            <i className="fa fa-trash" style={{color: 'var(--danger)'}} aria-hidden="true"/>
                        </button>
                    </div>
                    <div className="My-Report-Text">{report.text}</div>
                </div>
            </div>)
        });

        let currentProjectName = this._getProjectName(this.state.projectId);

        let months = moment.months().map((month, index) => {
            return {label: month, value: index};
        });

        return (
            <Page {...this.props} >
                <div className="col-xs-12">
                    <div className="Card">
                        <div className="Title"><span>New entry · {moment(new Date(this.state.year, this.state.month, 1)).format("MMMM YYYY")}</span></div>

                        <div className="Field-Row">
                            <div className="Input-Group">
                                <label>Month</label>
                                <Select
                                    name="month"
                                    value={this.state.month}
                                    onChange={(option) => this._onChangeSelect('month', option)}
                                    options={months}
                                />
                            </div>
                            <div className="Input-Group">
                                <label>Project</label>
                                <select className="form-control" value={this.state.projectId} onChange={event => this._onChangeInput('projectId', event)}>
                                    {options}
                                </select>
                            </div>
                        </div>

                        <div className="Input-Group">
                            <label>What did you work on?</label>
                            <textarea onChange={event => this._onChangeInput('text', event)} className="form-control" rows="8" value={this.state.text}
                                      placeholder="Describe your work for this project…"></textarea>
                        </div>

                        <div style={{textAlign: 'right'}}>
                            <button onClick={this._onClickSubmit} className="btn btn-primary" disabled={!this.state.text}>
                                <i className="fa fa-paper-plane" aria-hidden="true" /> Submit entry
                            </button>
                        </div>
                    </div>

                    <div className="Title" style={{padding: '4px 0 14px'}}><span>History · {currentProjectName || '—'}</span></div>

                    {myReports.length ? myReports :
                        <div className="Card"><div className="Empty"><i className="fa fa-file-text-o" /><div className="t">No entries this month</div><div className="s">Add your first report above.</div></div></div>}
                </div>
            </Page>
        );
    }
}

MyReports.propTypes = {
    user: PropTypes.object,
    projects: PropTypes.arrayOf(PropTypes.object),
    myReports: PropTypes.arrayOf(PropTypes.object),
};

MyReports.defaultProps = {
    user: {},
    projects: [],
    myReports: [],
};


function mapStateToProps(state) {
    const user = state.authentication.user;
    const projects = state.projects;
    const myReports = state.myReports;
    return {
        projects: projects,
        user: user,
        myReports: myReports,
    };
}

export default connect(mapStateToProps)(MyReports);



// WEBPACK FOOTER //
// ./src/screens/MyReports/index.js